export const options = {
  legend: {
    display: false
  },
  scales: {
    yAxes: [{
      stacked: true
    }]
  }
}

export const backgroundColors = [
  'rgba(0, 158, 227, .5)',
  'rgba(0, 136, 110, .5)',
  'rgba(153, 13, 13, .5)',
  'rgba(153, 13, 13, .5)'
]

export const borderColors = [
  'rgba(0, 158, 227, 1)',
  'rgba(0, 136, 110, 1)',
  'rgba(153, 13, 13, 1)',
  'rgba(153, 13, 13, 1)'
]



// WEBPACK FOOTER //
// ./src/js/constants/chart.js